// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"e3a2fbb1","264":"0072ac18","480":"712c9f69","638":"b4e500f2","738":"f47138e3"}[chunkId] + ".chunk.js";
};